import axios from 'axios';
import { isEqual } from 'lodash';
import ReportService from '../../common/services/reports-service';
import { getAdjustedEndDate } from '../../utils/report-utils';

import {
    DOMAIN_COVERAGE_FAILURE,
    DOMAIN_COVERAGE_REQUEST,
    DOMAIN_COVERAGE_SUCCESS,
} from './types/domain-coverage-action-types';
import {
    MESSAGE_VOLUME_COVERAGE_FAILURE,
    MESSAGE_VOLUME_COVERAGE_REQUEST,
    MESSAGE_VOLUME_COVERAGE_SUCCESS,
} from './types/message-volume-coverage-action-types';

import {
    currentReportParamsSelector,
    selectedDateOptionSelector
} from '../selectors/reports-selectors';
import { prevDomainCoverageParamsSelector } from '../selectors/domain-coverage-selectors';
import { prevMessageVolumeCoverageParamsSelector } from '../selectors/message-volume-coverage-selectors';


function requestDomainCoverage( params ){
    return {
        params,
        type: DOMAIN_COVERAGE_REQUEST,
    };
}
function receiveDomainCoverage( data ){
    return {
        payload: data,
        type: DOMAIN_COVERAGE_SUCCESS,
    };
}
function domainCoverageError( error ){
    return {
        error,
        type: DOMAIN_COVERAGE_FAILURE,
    };
}

function requestMessageVolumePolicyProgress( params ){
    return {
        params,
        type: MESSAGE_VOLUME_COVERAGE_REQUEST,
    };
}
function receiveMessageVolumePolicyProgress( data ){
    return {
        payload: data,
        type: MESSAGE_VOLUME_COVERAGE_SUCCESS,
    };
}
function messageVolumePolicyProgressFailure( error ){
    return {
        error,
        type: MESSAGE_VOLUME_COVERAGE_FAILURE,
    };
}

function fetchDomainCoverage( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( requestDomainCoverage( params ) );

        const reportService = new ReportService( DATA_API );

        return reportService.getDomainCoverage( params )
            .then(
                ( response ) => dispatch( receiveDomainCoverage( response.data ) ),
                ( error = {} ) => {
                    if( !axios.isCancel( error ) ){
                        return dispatch( domainCoverageError( error.response ) );
                    }
                }
            );
    };
}

function fetchMessageVolumePolicyProgress( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( requestMessageVolumePolicyProgress( params ) );

        const reportService = new ReportService( DATA_API );

        return reportService.getMessageVolumePolicyProgress( params )
            .then(
                ( response ) => dispatch( receiveMessageVolumePolicyProgress( response.data ) ),
                ( error = {} ) => {
                    if( !axios.isCancel( error ) ){
                        return dispatch( messageVolumePolicyProgressFailure( error.response ) );
                    }
                }
            );
    };
}

export function fetchMessageVolumeCoverageIfNeeded(){
    return ( dispatch, getState ) => {
        const state = getState();
        const prevParams = prevMessageVolumeCoverageParamsSelector( state );
        const currentParams = currentReportParamsSelector( state );

        if( !isEqual( currentParams, prevParams ) ){
            return dispatch( fetchMessageVolumePolicyProgress( currentParams ) );
        }
        else{
            return Promise.resolve();
        }
    };
}

export function fetchDomainCoverageIfNeeded(){
    return ( dispatch, getState ) => {
        const state = getState();
        const prevParams = prevDomainCoverageParamsSelector( state );
        const currentParams = currentReportParamsSelector( state );
        const option = selectedDateOptionSelector( state );
        if( !isEqual( currentParams, prevParams ) ){
            const newEnd = getAdjustedEndDate( option, currentParams.interval, currentParams.endDate );
            currentParams.endDate = newEnd;
            return dispatch( fetchDomainCoverage( currentParams ) );
        }
        else{
            return Promise.resolve();
        }
    };
}
